import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL } from '../data/content';

/**
 * Sticky bottom CTA. Appears only once the user scrolls past the first hero CTA.
 */
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      const past = entry.boundingClientRect.top < 0 && !entry.isIntersecting;
      setVisible(past);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-29" data-mp="2awcxi83qmwuf">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 320,
      damping: 30
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-navy/10 bg-cream/95 px-3 pb-[calc(env(safe-area-inset-bottom)+10px)] pt-3 backdrop-blur-sm" data-id="element-30" data-mp="2avbbj8l6opxx">
          <div className="mx-auto max-w-xl" data-id="element-31" data-mp="3331a3ofiixld">
            <a href={CHECKOUT_URL} className="animate-shake block w-full rounded-xl bg-brandred px-4 py-3.5 text-center text-sm sm:text-base font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_0_#9d0c24] focus:outline-none focus-visible:ring-4 focus-visible:ring-brandred/40" data-id="element-32" data-mp="2pc6028ta2ag7">
              🔴 Quiero la Ruta Anticoagulación · $15
            </a>
            <p className="mt-1.5 text-center text-[10px] font-semibold uppercase tracking-wide text-navy/50" data-id="element-33" data-mp="26dtjw33y80b4">
              Acceso inmediato · Pago único · Garantía 7 días
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}